import axios from "axios";
import { getToken, removeToken } from "../utils/token";
import { removeStoredUser } from "../utils/authStorage";
import { API_BASE_URL } from "./config";
import ROUTES from "../constants/routes";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const isBinaryDownload =
    config.responseType === "blob" || config.responseType === "arraybuffer";

  if (isBinaryDownload) {
    const accept =
      typeof config.headers.get === "function"
        ? config.headers.get("Accept")
        : config.headers.Accept || config.headers.accept;
    const hasExplicitAccept =
      accept && !String(accept).includes("application/json");

    if (typeof config.headers.set === "function") {
      if (!hasExplicitAccept) {
        config.headers.set("Accept", "*/*");
      }
      config.headers.delete("Content-Type");
    } else {
      if (!hasExplicitAccept) {
        config.headers.Accept = "*/*";
      }
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    }
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeToken();
      removeStoredUser();

      const isAuthPage = window.location.pathname.startsWith(ROUTES.LOGIN);

      if (!isAuthPage) {
        window.location.href = ROUTES.LOGIN;
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
